import React from 'react';
import { Link } from 'react-router-dom';

const Tesekkur: React.FC = () => {
  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Teşekkürler!</h1>
          <p className="page-subtitle">
            Mesajınız başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.
          </p>
        </div>
      </section>

      <section className="about-content" style={{background: 'var(--bg-primary)', paddingTop: '2.5rem', paddingBottom: '2.5rem'}}>
        <div className="container">
          <div style={{
            maxWidth: 800,
            margin: '0 auto',
            textAlign: 'center',
            background: 'white',
            borderRadius: '24px',
            padding: '3rem 2rem',
            boxShadow: '0 4px 20px 0 rgba(0,0,0,0.08)',
            border: '1px solid var(--gray-200)',
          }}>
            {/* Başarı İkonu */}
            <div style={{
              width: 80,
              height: 80,
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 2rem',
              boxShadow: '0 4px 16px 0 rgba(16, 185, 129, 0.3)',
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <h2 style={{
              fontSize: '2rem',
              fontWeight: 700,
              color: 'var(--text-primary)',
              marginBottom: '1rem',
            }}>
              Mesajınız Alındı!
            </h2>

            <p style={{
              fontSize: '1.1rem',
              color: 'var(--text-secondary)',
              lineHeight: 1.6,
              marginBottom: '2rem',
            }}>
              Değerli mesajınız için teşekkür ederiz. Uzman ekibimiz en kısa sürede sizinle iletişime geçecektir.
            </p>

            {/* Bilgi Kartları */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '1.5rem',
              marginBottom: '2.5rem',
            }}>
              <div style={{
                background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                color: 'white',
                padding: '1.5rem',
                borderRadius: '16px',
                textAlign: 'center',
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem',
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.72 19.72 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.13 1.05.37 2.07.72 3.06a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006.6 6.6l1.27-1.27a2 2 0 012.11-.45c.99.35 2.01.59 3.06.72A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 style={{fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem'}}>Hızlı Yanıt</h3>
                <p style={{fontSize: '0.9rem', opacity: 0.9, margin: 0}}>24 saat içinde dönüş yapıyoruz</p>
              </div>

              <div style={{
                background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                color: 'white',
                padding: '1.5rem',
                borderRadius: '16px',
                textAlign: 'center',
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem',
                }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 style={{fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem'}}>Profesyonel Hizmet</h3>
                <p style={{fontSize: '0.9rem', opacity: 0.9, margin: 0}}>Uzman ekibimizle kaliteli çözümler</p>
              </div>
            </div>

            {/* Butonlar */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}>
              <Link to="/" className="btn btn-primary btn-large">
                Ana Sayfaya Dön
              </Link>
              <a href="https://api.whatsapp.com/send/?phone=908505325989&text&type=phone_number&app_absent=0" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 className="btn btn-outline btn-large">
                WhatsApp'tan Yazın
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tesekkur; 